/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./model-select/model-select.component').then((m) => m.ModelSelectComponent),
    title: 'Model Selector'
  },
  {
    path: 'genAI',
    loadComponent: () => import('./aim-model/aim-landing-page/aim-landing-page.component').then((m) => m.AimLandingPageComponent),
    title: 'GenAI Model'
  }
];
